import { sendFeedback } from "../queries/feedbackQuery";

export const submitFeedback = async (formData) => {
  try {
    const response = await sendFeedback(formData);

    if (response?.success) {
      return {
        success: true,
        message: response.message,
      };
    } else {
      return {
        success: false,
        message: response?.message || "Unknown error",
      };
    }
  } catch (error) {
    console.error("Feedback submission error:", error);
    return {
      success: false,
      message: "Something went wrong while sending feedback.",
    };
  }
};
